import * as React from 'react'
import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'

import { cn } from '#/shared/lib/utils'

const tagVariants = cva(
  'inline-flex items-center justify-center rounded-sm px-1.25 py-0.75 text-xs whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'border border-gray-200 text-gray-500',
        muted: 'bg-gray-100 text-gray-500',
        warning: 'bg-orange-100 text-orange-500',
        success: 'bg-green-50 text-green-500',
        info: 'bg-blue-50 text-primary',
        destructive: 'bg-red-50 text-destructive',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface TagProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof tagVariants> {}

export function Tag({ className, variant, ...props }: TagProps) {
  return <span className={cn(tagVariants({ variant }), className)} {...props} />
}
